/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ajax } from 'rxjs/ajax';
import { concat, of, from, defer } from 'rxjs';
import { switchMap, filter, catchError, toArray, mergeAll, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import isEmpty from 'lodash/isEmpty';

import { STATUS } from 'sarsaparilla';

import { getTourRatingReviewUrl } from '../api/endpoints';
import { averageMobileReviews } from '../utils';

import {
    FETCH_TOUR_RATINGS,
    setFetchTourRatingsByFacilityStatus,
    fetchTourRatingsByFacilitySuccess,
    fetchTourRatingsByFacilityError,
} from '../actions/tourRatingsActions';

const processRatingReviewResponse = (response) => {
    const data = {};

    if (!isEmpty(response)) {
        const {
            aggregate_cell_coverage_ratings: aggregateMobileReviews,
            average_rating: averageRating,
            number_of_ratings: reviewCount,
        } = response;

        data.averageMobileRating = averageMobileReviews(aggregateMobileReviews);
        data.averageRating = averageRating;
        data.reviewCount = reviewCount;
    }

    return data;
};

export function fetchTourRatingsByFacility(actions$) {
    return actions$.pipe(
        ofType(FETCH_TOUR_RATINGS),
        filter(({ payload }) => !!payload),
        switchMap(({ payload }) => {
            const { tourIds } = payload;

            const requests = tourIds.map((id) => {
                return defer(() => ajax.getJSON(getTourRatingReviewUrl(id)));
            });

            const ajax$ = from(requests).pipe(mergeAll(5), toArray());

            return concat(
                of(setFetchTourRatingsByFacilityStatus(STATUS.PENDING)),
                ajax$.pipe(
                    map((responses) => {
                        const data = {};

                        if (Array.isArray(responses)) {
                            responses.forEach((item) => {
                                const tourId = item?.location_id;
                                if (tourId) {
                                    data[tourId] = processRatingReviewResponse(item);
                                }
                            });
                        }
                        return fetchTourRatingsByFacilitySuccess(data);
                    }),
                    catchError((error) => of(fetchTourRatingsByFacilityError(error)))
                )
            );
        })
    );
}
